export default class SelectCourse {
    get SELECTORS() {
        return {
            item: ".select-course__list__item",
            back: ".select-course__list__back",
            selected: ".select-course__list__item--selected"
        };
    }

    get CLASSNAMES() {
        return {
            item: "select-course__list__item",
            back: "select-course__list__back",
            selected: "select-course__list__item--selected",
            close: "close"
        };
    }

    get LOADING_LABEL(){
        if(document.documentElement.lang === "ar"){
            return "جار التحميل";
        }
        return "Loading...";
    }

    constructor() {
        this.clickOutside = this.clickOutside.bind(this);
        this.backToSchools = this.backToSchools.bind(this);
        this.backToProgrammes = this.backToProgrammes.bind(this);
        this.component = document.querySelector(
            '[data-component="SelectCourse"]'
        );
        this.schoolInput = this.component.querySelector("#school");
        this.programmeInput = this.component.querySelector("#programme");
        this.subareaInput = this.component.querySelector("#subarea");
        this.textInput = this.component.querySelector("#text-course");
        this.textInput.disabled = true;
        this.container = this.component.querySelector(".select-course");
        this.toggler = this.container.querySelector(".select-course--toggler");
        this.list = this.container.querySelector(".select-course__list");
        this.backElement = this.component.querySelector(this.SELECTORS.back);
        this.schools = this.list.querySelectorAll(this.SELECTORS.item);
        this.programmes;
        this.selectedSchool;
        this.selectedProgramme;
        this.selectedCourse;
        this.toggler.addEventListener("click", () => this.toggleList());
        this.subDirectory = 'landing_pages';
    }

    toggleList() {
        this.container.classList.toggle(this.CLASSNAMES.close);
        document.addEventListener("click", this.clickOutside);
        this.list.addEventListener("click", e => e.stopPropagation());
        this.schools.forEach(school => {
            school.addEventListener("click", () =>
                this.fetchProgrammes(school)
            );
        });
    }

    fetchProgrammes(school) {
        let id = school.dataset.id;
        this.schoolInput.value = id;
        this.selectedSchool = school.innerHTML;
        this.textInput.value = this.selectedSchool + " / ";
        //Valid for production
        let subDirectory = window.location.pathname.includes(this.subDirectory) ? '/' + this.subDirectory : '';
        let lang = document.documentElement.lang;
        let url = subDirectory + "/" + lang + "/programmes-from-school/" + id;
        this.list.innerHTML = "";
        this.list.appendChild(this.listElement(this.LOADING_LABEL));
        fetch(url)
            .then(res => res.json())
            .then(res => this.showProgrammes(res))
            .catch(err => console.log(err));
    }

    showProgrammes(programmes) {
        this.list.innerHTML = "";
        programmes.forEach(programme => {
            let item = this.listElement(programme.name);
            if (programme.has_subareas) {
                item.addEventListener("click", () =>
                    this.fetchCourses(programme)
                );
            } else {
                item.addEventListener("click", e =>
                    this.selectCourse(e, programme)
                );
            }
            this.list.appendChild(item);
        });
        this.programmes = this.list.querySelectorAll(this.SELECTORS.item);
        this.backElement.addEventListener("click", this.backToSchools);
        this.list.appendChild(this.backElement);
    }

    fetchCourses(programme) {
        this.programmeInput.value = programme.id;
        this.selectedProgramme = programme.name;
        this.textInput.value =
            this.selectedSchool + " / " + this.selectedProgramme + " / ";
        //Valid for production
        let subDirectory = window.location.pathname.includes(this.subDirectory) ? '/' + this.subDirectory : '';
        let id = programme.id;
        let lang = document.documentElement.lang;
        let url = subDirectory + "/" + lang + "/subareas-from-programme/" + id;
        this.list.innerHTML = "";
        this.list.appendChild(this.listElement(this.LOADING_LABEL));
        fetch(url)
            .then(res => res.json())
            .then(res => this.showCourses(res))
            .catch(err => console.log(err));
    }

    showCourses(courses) {
        this.list.innerHTML = "";
        courses.forEach(course => {
            let item = this.listElement(course.name);
            item.addEventListener("click", e => this.selectCourse(e, course));
            this.list.appendChild(item);
        });
        this.backElement.removeEventListener("click", this.backToSchools);
        this.backElement.addEventListener("click", this.backToProgrammes);
        this.list.appendChild(this.backElement);
    }

    selectCourse(e, course) {
        let prevCourse = this.list.querySelector(this.SELECTORS.selected);
        if (prevCourse) {
            prevCourse.classList.remove(this.CLASSNAMES.selected);
        }
        let newCourse = e.target;
        newCourse.classList.add(this.CLASSNAMES.selected);
        this.container.classList.add(this.CLASSNAMES.close);
        this.selectedCourse = course.name;
        if (course.has_subareas === false) {
            this.textInput.value =
                this.selectedSchool + " / " + this.selectedCourse;
            this.programmeInput.value = course.id;
        } else {
            this.textInput.value =
                this.selectedSchool +
                " / " +
                this.selectedProgramme +
                " / " +
                this.selectedCourse;
            this.subareaInput.value = course.id;
        }
    }

    backToProgrammes() {
        this.programmeInput.value = "";
        this.subareaInput.value = "";
        this.list.innerHTML = "";
        this.textInput.value = this.selectedSchool + " / ";
        this.programmes.forEach(programme => {
            this.list.appendChild(programme);
        });
        this.backElement.removeEventListener("click", this.backToProgrammes);
        this.backElement.addEventListener("click", this.backToSchools);
        this.list.appendChild(this.backElement);
    }

    backToSchools() {
        this.schoolInput.value = "";
        this.programmeInput.value = "";
        this.list.innerHTML = "";
        this.textInput.value = "";
        this.schools.forEach(school => {
            this.list.appendChild(school);
        });
    }

    clickOutside(e) {
        if (e.target != this.toggler) {
            this.container.classList.add(this.CLASSNAMES.close);
            document.removeEventListener("click", this.clickOutside);
        }
    }

    listElement(text) {
        let listElement = document.createElement("div");
        listElement.classList.add(this.CLASSNAMES.item);
        listElement.innerHTML = text;
        return listElement;
    }
}
